var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyzedAutoresponderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38369 9.03778L8.32712 6.2201C8.27509 6.09513 8.22106 5.94673 8.16503 5.7749C8.109 5.60307 8.05297 5.41757 7.99694 5.2184C7.94491 5.41757 7.89088 5.60502 7.83485 5.78076C7.77882 5.95259 7.72479 6.10295 7.67277 6.23182L6.6222 9.03778H9.38369ZM12.2352 12.2362H10.9866C10.8465 12.2362 10.7324 12.203 10.6444 12.1366C10.5563 12.0663 10.4903 11.9804 10.4463 11.8789L9.79792 10.1508H6.20197L5.55362 11.8789C5.5216 11.9687 5.45957 12.0507 5.36752 12.1249C5.27547 12.1991 5.16141 12.2362 5.02533 12.2362H3.76465L7.1805 3.76562H8.82539L12.2352 12.2362Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzedAutoresponderIcon);
export default __webpack_public_path__ + "static/media/AnalyzedAutoresponderIcon.43f0db625cbe7c6e1b6c8fd573c07dfb.svg";
export { ForwardRef as ReactComponent };